const IN_PAGE_LINKS = [
  { path: '#coding-competitions', title: 'Coding Competitions' },
  { path: '#coding-quizzes', title: 'Coding Quizzes' },
  { path: '#coding-masterclasses', title: 'Coding Masterclasses' },
  { path: '#coding-worksheets', title: 'Coding Worksheets' },
  { path: '#coding-blogs', title: 'Coding Blogs' },
  { path: '#coding-guides', title: 'Coding Guides' },
  { path: '#coding-webinars', title: 'Coding Webinars' },
  { path: '#courses', title: 'Coding Courses' },
  { path: '#courses-by-grade', title: 'Coding Courses by grade' },
]

const TableOfContents = () => {
  return (
    <div className="px-5 text-grey container mx-auto my-12 lg:my-16 flex flex-col">
      <h2 className="text-2xl lg:text-4xl font-600 mb-4">Table of contents</h2>
      <ol className="font-600 text-xl flex flex-col space-y-3 pl-5">
        {IN_PAGE_LINKS.map((link) => (
          <li className="text-orange hover:underline" key={link.title}>
            <a href={link.path}>{link.title}</a>
          </li>
        ))}
      </ol>
    </div>
  )
}

export default TableOfContents
